import { render, staticRenderFns } from "./allsNews.vue?vue&type=template&id=5534e2bf&scoped=true&"
import script from "./allsNews.vue?vue&type=script&lang=js&"
export * from "./allsNews.vue?vue&type=script&lang=js&"
import style0 from "./allsNews.vue?vue&type=style&index=0&id=5534e2bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5534e2bf",
  null
  
)

export default component.exports